const data = ['hokiskateboards'];

export default data;
